import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import { EP3_quest3Data, EP3_quest3Selected } from '../../../Redux/Slices/selectedOptionSlice';
import './F63.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame63() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    let quest1 = useSelector(EP3_quest3Data);

        return (
            <div className="F63_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F63_entryBox">
                    <div className="F63_heading">
                        {
                            language === 'english' ?
                                <p className="F63_headingEnglish">How should Saira respond to the girl who thinks that menstruation is a curse?  </p>
                                :
                                <p className="F63_headingUrdu">سائرا کو اس لڑکی کو کیا جواب دینا چاہیے جو سمجھتی ہے کہ ماہواری کوئی سزا ہے</p>
                        }
                    </div>
                    <div className="F63_options">
                        <div onClick={() => { dispatch(EP3_quest3Selected('A'), dispatch(pageUp())) }} className={language === 'english' ? "F63_option" : "F63_optionUrdu"}>
                            {language === 'english' ? `A. ${quest1.headingEnglish.A}` : `${quest1.headingUrdu.A}`}
                        </div>

                        <div onClick={() => { dispatch(EP3_quest3Selected('B'), dispatch(pageUp())) }} className={language === 'english' ? "F63_option" : "F63_optionUrdu"}>
                            {language === 'english' ? `B. ${quest1.headingEnglish.B}` : `${quest1.headingUrdu.B}`}
                        </div>
                        
                    </div>

                    <div className="F63_timeline">
                        <div className='F63_timelineBar'>
                            <div className='F63_timelineFill'></div>
                            <span className='F63_timelineText'>11/14</span>
                        </div>
                    </div>

                    <div className="F63_nextFrames">
                        <div className="F63_nextFrame1"></div>
                        <div className="F63_nextFrame2"></div>
                        <div className="F63_nextFrame3"></div>
                    </div>

                </div>
            </div>
        )
}

export default Frame63;